import { Grid } from '@material-ui/core';
import React, { } from 'react';

export const FilteredEntityLayout = ({ children }) => (
  React.createElement(Grid, { container: true, style: { position: 'relative' },}
    , children
  )
);
